// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l6-1";
export var rowFirst = "_l6-3";
export var rowLast = "_l6-5";
export var rowMiddle = "_l6-4";
export var ticketListScroll = "_l6-2";
export var ticketStack = "_l6-0";